import React from 'react';
import styled from 'styled-components';

export const HiddenLabel = styled.label`
    display: none; 
`;

// export {
//     HiddenLabel as default
// }


// WEBPACK FOOTER //
// ./src/js/components/Form/StyledComponents/HiddenLabel.jsx